import { PRIVACY_SECTIONS } from '@bb/shared';
import { createFileRoute } from '@tanstack/react-router';
import { LegalDoc } from '@/features/shared/legal-doc';
import { ensureNamespace } from '@/lib/i18n';

export const Route = createFileRoute('/privacy')({
  loader: () => ensureNamespace('legal'),
  component: () => <LegalDoc doc="privacy" sections={PRIVACY_SECTIONS} />,
});
